


















import Vue, { PropType } from 'vue'

import { MessageChannel } from 'base/store/state.interface'

import ChatNavigationView from '../ChatNavigationView.vue'
import { DraggedChatElement } from './dragged-chat-element.interface'
import MessengerDropzone from './MessengerDropzone.vue'

export default Vue.extend({
  components: {
    ChatNavigationView,
    MessengerDropzone
  },
  props: {
    isPrimary: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    draggedChat: {
      type: Object as PropType<DraggedChatElement | null>,
      default: null
    },
    showDropzones: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    id: {
      type: Number as PropType<number>,
      required: true
    },
    channels: {
      type: Array as PropType<MessageChannel[]>,
      default: []
    }
  }
})
